import { render, staticRenderFns } from "./CrawledDocuments.vue?vue&type=template&id=1f719bd4&scoped=true"
import script from "./CrawledDocuments.vue?vue&type=script&lang=js"
export * from "./CrawledDocuments.vue?vue&type=script&lang=js"
import style0 from "./CrawledDocuments.vue?vue&type=style&index=0&id=1f719bd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f719bd4",
  null
  
)

export default component.exports